// Modules
import ReactPaginate from "react-paginate";

// Hooks
import usePagination from "hooks/usePagination";

// Redux
import { useAppSelector } from "redux/hooks";
import { forcePageSelector } from "redux/pagination/paginationSlice";
import { urlPathSelector } from "redux/filters/filtersSlice";

// Utils
import { changeParameterInQueryString } from "utils/queryString";

// Constants
import { QueryStringPrimaryKeys } from "constants/urlEnum";

const Pagination = () => {
	const forcePage = useAppSelector(forcePageSelector);
	const urlPath = useAppSelector(urlPathSelector);
	const { pageCount, currentPage, onClickPagination } = usePagination(urlPath);

	return (
		<>
			<div id="ctl00_Utility_RR_LS_pNavigazione" className="paginazione paginazioneDOWN">
				{pageCount > 1 && (
					<span className="numeriPagina">
						<ReactPaginate
							containerClassName=""
							breakLabel="..."
							nextLabel={currentPage < pageCount - 1 ? "Avanti" : ""}
							nextLinkClassName={currentPage < pageCount - 1 ? "avanti" : "hide-button"}
							onClick={(numberPage) => {
								onClickPagination(numberPage);
							}}
							hrefBuilder={(numberPage) => changeParameterInQueryString(urlPath, QueryStringPrimaryKeys.PAGE, numberPage)}
							pageRangeDisplayed={5}
							marginPagesDisplayed={1}
							pageCount={pageCount}
							previousLabel={currentPage > 0 ? "Indietro" : ""}
							previousLinkClassName={currentPage > 0 ? "indietro" : "hide-button"}
							initialPage={forcePage === null ? currentPage : undefined}
							activeLinkClassName="evidenziato"
							forcePage={forcePage ?? undefined}
						/>
					</span>
				)}
			</div>
		</>
	);
};

export default Pagination;
